import type { ReactElement } from 'react';

export const GoogleMark = (): ReactElement => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="#4285F4"
      d="M23.49 12.27c0-.79-.07-1.55-.2-2.27H12v4.3h6.45a5.52 5.52 0 0 1-2.39 3.62v3.01h3.88c2.27-2.09 3.55-5.17 3.55-8.66Z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.96-1.07 7.95-2.91l-3.88-3.01c-1.07.72-2.44 1.15-4.06 1.15-3.12 0-5.77-2.1-6.72-4.93H1.29v3.1A12 12 0 0 0 12 24Z"
    />
    <path
      fill="#FBBC05"
      d="M5.29 14.3A7.2 7.2 0 0 1 4.92 12c0-.8.14-1.58.37-2.3V6.6h-4A12 12 0 0 0 0 12c0 1.94.46 3.78 1.29 5.4l4-3.1Z"
    />
    <path
      fill="#EA4335"
      d="M12 4.77c1.76 0 3.34.61 4.59 1.82l3.43-3.43C17.96 1.15 15.24 0 12 0A12 12 0 0 0 1.29 6.6l4 3.1c.95-2.83 3.6-4.93 6.71-4.93Z"
    />
  </svg>
);
